import _ from 'lodash'

const calcItemTotal = ({ specification = [], stayInTaste = [], takeoutTaste = [] }) => {
  const inTasteById = _.keyBy(stayInTaste, 'id')
  const outTasteById = _.keyBy(takeoutTaste, 'id')
  const specSumList = specification.map(({ price, combination = []}) => {
    const combinSumList = combination.map(({ taste = [], quantity, takeout }) => {
      const tasteSum = _.sum(taste.map(tasteId => {
        if ( takeout ) {
          return _.get(outTasteById, [tasteId, 'price'], 0)
        } else {
          return _.get(inTasteById, [tasteId, 'price'], 0)
        }
      }))

      return {
        total: price * quantity,
        tasteTotal: tasteSum * quantity
      }
    })

    return {
      total: _.sumBy(combinSumList, 'total'),
      tasteTotal: _.sumBy(combinSumList, 'tasteTotal')
    }
  })

  return {
    total: _.sumBy(specSumList, 'total'),
    tasteTotal: _.sumBy(specSumList, 'tasteTotal')
  }

}
const calcListTotal = (list) => {
  const listSum = list.map(calcItemTotal)
  return {
    total: _.sumBy(listSum, 'total'),
    tasteTotal: _.sumBy(listSum, 'tasteTotal')
  }
}

export default calcListTotal